<template>
  <div class="ws-event small" :class="{disabled: disabled}" @click="emit">
    <div class="label">{{ label }}</div>
    <div class="cooldown">
      <div class="cooldown-bar" :style="{
        'transition-duration': timeout + 'ms',
        width: cooldown_w,
        opacity: cooldown_op
      }"></div>
    </div>
  </div>
</template>

<script>
import { EventBus } from '../EventBus.js';

export default {
  data () {
    return {
      disabled: false,
      disabled_timeout: null
    };
  },
  computed: {
    cooldown_w () {
      return this.disabled ? 0 : '100%';
    },
    cooldown_op () {
      return this.disabled ? 1 : 0;
    }
  },
  methods: {
    emit () {
      if (this.disabled) return;

      clearTimeout(this.disabled_timeout);

      const msg = {
        channel: this.channel,
        message: this.message
      };

      EventBus.$emit('send msg', msg);

      this.disabled = true;

      this.disabled_timeout = setTimeout(() => {
        this.disabled = false;
      }, this.timeout);
    }
  },
  destroyed () {
    clearTimeout(this.disabled_timeout);
  },
  props: {
    label: String,
    timeout: {
      type: Number,
      default: 2500
    },
    channel: {
      type: String,
      default: 'broadcast'
    },
    message: {
      type: [String, Object, Array, Number, Boolean],
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
  .ws-event {
    cursor: pointer;
    width: 33%;
    flex-shrink: 0;
    margin-bottom: 20px;
    user-select: none;
  }

  .label {
    padding-bottom: 10px;
  }

  .disabled {
    opacity: 0.3;
  }

  .cooldown {
    height: 3px;
    width: 100%;
    padding-right: 25%;

    .cooldown-bar {
      transition-property: width;
      transition-timing-function: linear;
      width: 100%;
      height: 100%;
      background-color: #aaa;
    }
  }
</style>
